import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ETypeLien } from '../entites/enums/type-lien-document';
import { DocumentRevisionEntite } from '../entites/historique-document/document-revision';

@Injectable({ providedIn: 'root' })
export class DocumentRevisionService {
    private baseUrl = environment.apiBaseUrl + 'documentrevision';
    private httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    constructor(private http: HttpClient) {}

    /**
     * Lists coalesced revisions for a document.
     */
    obtenirHistorique(typeLien: ETypeLien, entityId: number): Observable<DocumentRevisionEntite[]> {
        return this.http.get<DocumentRevisionEntite[]>(`${this.baseUrl}/${typeLien}/${entityId}`);
    }

    /**
     * Gets one revision including snapshot JSON when still available.
     */
    obtenirRevision(documentRevisionId: number): Observable<DocumentRevisionEntite> {
        return this.http.get<DocumentRevisionEntite>(`${this.baseUrl}/detail/${documentRevisionId}`);
    }

    /**
     * Restores a document to a revision snapshot.
     */
    restaurer(documentRevisionId: number): Observable<{ estUnSucces: boolean; message?: string }> {
        return this.http.post<{ estUnSucces: boolean; message?: string }>(
            `${this.baseUrl}/${documentRevisionId}/restore`,
            {},
            this.httpOptions
        );
    }
}
